export const getAuthorizationDocumentMenu = (screenCode: string) =>
  `portal-document/field/delegated/${screenCode}`;

export const getAuthorizationDocumentSubMenu = (screenCode: string) =>
  `portal-document/category/${screenCode}`;

export const getAuthorizationDocsUrl = (screenCode: string) =>
  `portal-document/document/delegated/${screenCode}`;

export const getAuthorizationDocumentDetailUrl = (
  screenCode: string,
  docsId: string
) => `portal-document/document/delegated/${screenCode}/${docsId}`;

export const getDocFormUrl = (screenCode: string) =>
  `portal-document/document/delegated/${screenCode}/form`;
